import * as React from 'react';

interface BetaProps extends React.SVGProps<SVGSVGElement> {}

/**
 * A fixed, full-screen SVG background for any content designated as "beta". The props let you
 * adjust fill, stroke, and stroke-width. See `styles/_content.scss` for height, rotation, and
 * media queries.
 *
 * Example usage
 * ```tsx
 * # Test heading
 *
 * <Beta />
 *
 * ## Test subheading
 * ```
 */
export const Beta = ({
  fill = 'none',
  stroke = '#F0F0F0',
  strokeWidth = 3,
  ...props
}: BetaProps) => {
  return (
    <div className="beta-bg fixed cover flex align-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={fill}
        viewBox="0 0 346 101"
        {...props}>
        <path
          stroke={stroke}
          strokeWidth={strokeWidth}
          d="M3.624 2.445h-1.5V99.5h33.524c12.08-.085 19.799-.298 23.055-.65h.004c5.243-.578 9.73-2.122 13.399-4.69l.003-.002c3.682-2.59 6.559-6.02 8.63-10.253 2.106-4.256 3.17-8.652 3.17-13.172 0-5.736-1.634-10.789-4.929-15.09-2.673-3.491-6.257-6.122-10.692-7.922 2.895-1.836 5.29-4.226 7.169-7.162 2.552-3.922 3.833-8.247 3.833-12.94 0-4.309-1.024-8.232-3.094-11.73-2.027-3.468-4.591-6.269-7.699-8.371-3.057-2.098-6.535-3.457-10.41-4.09-3.77-.663-9.413-.983-16.867-.983H3.624ZM48.678 39.54c-1.688.2-6.183.31-13.617.31H24.114V21.1h9.407c8.97 0 14.275.11 16.057.311 2.91.355 4.89 1.35 6.16 2.825l.011.014.013.014c1.328 1.467 2.05 3.436 2.05 6.051 0 2.7-.823 4.757-2.383 6.317-1.545 1.545-3.747 2.552-6.75 2.908Zm4.27 40.56-.019.004-.019.005c-1.655.346-5.825.545-12.717.545H24.114v-22.15h13.834c4.298 0 7.816.112 10.562.333 2.78.222 4.66.549 5.752.93l.007.003c2.355.81 4.063 2.069 5.223 3.737 1.165 1.674 1.785 3.756 1.785 6.329 0 3.059-.817 5.346-2.313 7.02l-.002.001c-1.51 1.696-3.488 2.785-6.013 3.244ZM97.013 98v1.5h74.536V80.653h-52.545V58.054h47.22V39.208h-47.22V21.356h50.748V2.446H97.012V98Zm108.811 0v1.5h21.991V21.356h27.844V2.446h-77.743v18.91h27.908V98Zm135.717 1.5h2.217l-.824-2.058-37.66-94.054-.378-.943h-22.122l-.372.956-36.634 94.055-.796 2.044H268.361l.359-.988 7.404-20.376h35.515l7.843 20.402.369.962h21.689Zm-58.486-40.211 10.575-29.055 10.789 29.055h-21.364Z"
        />
      </svg>
    </div>
  );
};
